import { ActivityFeed } from "../../components/ActivityFeed";

/**
 * SÖZLEŞME FAALİYET ZAMAN ÇİZELGESİ (CLOS-230 `[197]`, alt görev CLOS-1036).
 *
 * ### ⚠ Yeni bir çekirdek DEĞİL — mevcut CLOS-281 taşıyıcısının bağlamsal kullanımı
 *
 * Kart: *"zaman çizelgesi CLOS-281 operasyonel Aktivite projeksiyonunu kullanır."*
 * `ActivityFeed` (CLOS-283 `[055]`) bu sözleşmeyi zaten uyguluyor — sunucudan türetilen
 * cümle, maskeli satır, boş/hata/yükleniyor durumları, erişim süzmesi. İkinci bir
 * uygulama yazmak, ikisinin bir gün ayrışacağı bir kopya doğururdu.
 *
 * Bu dosya yalnız BAĞLAMI sabitliyor: `entityType=contract`. Sözleşme domain olayları
 * (`contract.*`) `lib/activity/projector.ts`'te ve erişim kapısı `lib/activity/access.ts`'te
 * (`contract.view` + CLOS-93 kayıt erişimi) zaten kurulu.
 */
export function ContractTimelineSection({ contractId }: { contractId: string }) {
  return (
    <ActivityFeed entityType="contract" entityId={contractId} title="Faaliyet zaman çizelgesi" />
  );
}
